export default {
  startRecording: 'Start Recording',
  stopRecording: 'Stop Recording',
  recordAgain: 'Record Again',
  denied: 'Speak your answer out loud.',
  deniedNotice: 'My Move is not able to access your microphone. Your browser settings may be blocking it.',
};
